import { z } from 'zod';
import { DataSetVersionStatus } from 'libs/end-to-end/src/types/databases/data-sets/data-set-version-status';
import { UnixTimestamp } from 'libs/end-to-end/src/types/databases/analysis/database-analysis';
import { DataSet } from 'libs/end-to-end/src/types/databases/data-sets/data-set';

export const DataSetVersion = z.object({
  dataSetVersion: z.string(),
  status: DataSetVersionStatus,
  userUploadId: z.string().nullable(),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp,
  error: z.unknown().optional(),
});

export type DataSetVersion = z.infer<typeof DataSetVersion>;

export const DataSetVersionFiles = z.object({
  fileNames: z.array(z.string()),
  fileConsoleUrls: z.record(z.string(), z.string()),
});

export type DataSetVersionFiles = z.infer<typeof DataSetVersionFiles>;

export const DataSetVersions = z.object({
  versions: z.array(DataSetVersion),
  versionFiles: z.record(z.string(), DataSetVersionFiles),
  totalNumberOfVersionFiles: z.record(z.string(), z.number()),
  pagination: z
    .object({
      total: z.number(),
      page: z.number(),
      limit: z.number(),
      totalPages: z.number(),
    })
    .optional(),
});

export type DataSetVersions = z.infer<typeof DataSetVersions>;

export const DataSetVersionFull = z.object({
  dataSet: DataSet,
  dataSetVersion: DataSetVersion,
  fileNames: z.array(z.string()),
  fileConsoleUrls: z.record(z.string(), z.string()),
  totalNumberOfFiles: z.number(),
});

export type DataSetVersionFull = z.infer<typeof DataSetVersionFull>;

export const DataSetVersionsFull = z.object({
  fullVersions: z.array(DataSetVersionFull),
});

export type DataSetVersionsFull = z.infer<typeof DataSetVersionsFull>;
